import http from '../api'
import { Filters, APIPaginatedResponse, Pagination, APIResponse } from '../types'
import { getRequestParamString } from '../utils/utils'
import { TypeStaff, TypeStaffCreate, TypeStaffUpdate } from '../../types/Staff'

const apiPath = import.meta.env.VITE_API_PATH

async function getStaff(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  return await http.get<APIPaginatedResponse<TypeStaff>>(apiPath + 'staff' + getRequestParamString(filters, pagination))
}

async function getStaffByUuid(uuid: string) {
  return await http.get<APIResponse<TypeStaff>>(apiPath + `staff/${uuid}`)
}

async function createStaff(input: TypeStaffCreate) {
  return await http.post<APIResponse<TypeStaff>>(apiPath + 'staff', input)
}

async function updateStaff(uuid: string, input: TypeStaffUpdate) {
  return await http.patch<APIResponse<TypeStaff>>(apiPath + `staff/${uuid}`, input)
}

async function deactivateStaff(uuid: string, reason: string) {
  return await http.patch<APIResponse<TypeStaff>>(apiPath + `staff/${uuid}/deactivate`, {
    deactivation_reason: reason,
  })
}

async function reactivateStaff(uuid: string, reason: string) {
  return await http.patch<APIResponse<TypeStaff>>(apiPath + `staff/reactivate/${uuid}`, {
    reactivation_reason: reason,
  })
}

export default {
  getStaff,
  getStaffByUuid,
  createStaff,
  updateStaff,
  deactivateStaff,
  reactivateStaff,
}
